import React from 'react';
import { Button } from 'react-bootstrap';

import './style.css';

export default class Home extends React.Component {
  render() {
    return (
      <div className="page-space-top page-space-bottom">
        <div className="container intro-section">
          <div className="row justify-content-lg-between align-items-center">
            <div className="col-12">
              <h1 className="mb-3 mb-lg-4">ESA letter from the<br/> comfort of your home</h1>
              <div className="text-muted text-large mb-3 mb-lg-4">
                <p>
                  Gain full, legal, free access to all:&nbsp; <span className="text-primary">"No Pet" Housing</span>
                  <br />
                  without extra fees & unfair deposits!
                </p>
              </div>
              <ul className="text-medium mb-3 mb-lg-4">
                <li>Federal Protection to Have Your ESA with You</li>
                <li>All You Need to Live with Your ESA</li>
                <li>Easy Process, 99% Approved, Just $99</li>
                <li>Federal, State, HIPAA Law Compliant</li>
                <li>100% Money Back Guarantee</li>
                <li>Licensed in All 50 States</li>
                <li>Same Day Delivery</li>
              </ul>
              <Button size="lg" onClick={() => {this.props.history.push('/letters')}}>
                Get started
              </Button>
            </div>
          </div>

          <div className="col-lg-8 intro-image-container mt-5 mt-lg-0 pr-xl-0 pr-lg-0">
            <figure className="w-100">
              <img src="/images/intro.svg" width="100%" />
            </figure>
          </div>
        </div>

        <div className="container esa-intro-section bn-space-top">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <h2 className="text-primary mb-3 mb-lg-4">What is an <br/>Emotional <br/>Support Animal?</h2>
              <p className="text-large">
                Any animal that helps alleviate symptoms of mental or emotional disability.
              </p>
              <ul className="text-large">
                <li>No training requirements.</li>
                <li>Protected under federal laws.</li>
                <li>ESA letter required.</li>
              </ul>
            </div>
            <div className="col-lg-7 mb-3">
              <div className="row mx-gutters-2 d-none d-md-flex">
                <div className="col-md-5">
                  <div className="align-items-center card-bordered heading-card p-3">
                    <p className="mb-0 text-large">Benefits</p>
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="row mx-gutters-2">
                    <div className="col-md-6">
                      <div className="align-items-center card-bordered heading-card p-3">
                        <p className="mb-0 text-large">ESA</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="align-items-center card-bordered heading-card p-3">
                        <p className="mb-0 text-large">Pet</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mx-gutters-2 mt-3 d-none d-md-flex">
                <div className="col-md-5">
                  <div className="align-items-center card-bordered">
                    <div className="p-3 item-bordered">
                      <p className="mb-0 text-medium">
                        Reduce effects of mental or emotional disability, to live happier and healthier.
                      </p>
                    </div>
                    <div className="p-3 item-bordered">
                      <p className="mb-0 text-medium">
                        Less size, age, and breed restrictions. Access where otherwise not allowed.
                      </p>
                    </div>
                    <div className="p-3 item-bordered">
                      <p className="mb-0 text-medium">
                        Save money in housing. Avoid "No Pet" policies and pet deposits.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="row mx-gutters-2">
                    <div className="col-md-6">
                      <div className="card-bordered">
                        <div className="d-flex justify-content-center p-3 item-bordered">
                          <span className="align-self-center text-primary big-icon fa fa-check" />
                        </div>
                        <div className="d-flex justify-content-center p-3 item-bordered">
                          <span className="align-self-center text-primary big-icon fa fa-check" />
                        </div>
                        <div className="d-flex justify-content-center p-3 item-bordered">
                          <span className="align-self-center text-primary big-icon fa fa-check" />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card-bordered">
                        <div className="d-flex justify-content-center p-3 item-bordered">
                          <span className="align-self-center text-primary big-icon fa fa-check" />
                        </div>
                        <div className="d-flex justify-content-center p-3 item-bordered">
                          <span className="align-self-center text-danger big-icon fa fa-close" />
                        </div>
                        <div className="d-flex justify-content-center p-3 item-bordered">
                          <span className="align-self-center text-danger big-icon fa fa-close" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* mobile layout */}
              <div className="align-items-center card-bordered mt-3 p-3 d-md-none">
                <div className="row">
                  <div className="col-8">
                    <p className="mb-0 text-large">Benefits</p>
                  </div>
                  <div className="col-4 d-flex justify-content-around">
                    <p className="mb-0 text-large text-muted">ESA</p>
                    <p className="mb-0 text-large text-muted">Pet</p>
                  </div>
                </div>
              </div>

              <div className="align-items-center card-bordered mt-3 p-3 d-md-none">
                <div className="row">
                  <div className="col-8">
                    <p className="mb-0 text-medium">
                      Reduce effects of mental or emotional disability, to live happier and healthier.
                    </p>
                  </div>
                  <div className="col-4 d-flex justify-content-around">
                    <span className="align-self-center text-primary fa fa-check" />
                    <span className="align-self-center text-primary fa fa-check" />
                  </div>
                </div>
              </div>

              <div className="align-items-center card-bordered mt-3 p-3 d-md-none">
                <div className="row">
                  <div className="col-8">
                    <p className="mb-0 text-medium">
                      Less size, age, and breed restrictions. Access where otherwise not allowed.
                    </p>
                  </div>
                  <div className="col-4 d-flex justify-content-around">
                    <span className="align-self-center text-primary fa fa-check" />
                    <span className="align-self-center text-danger fa fa-close" />
                  </div>
                </div>
              </div>

              <div className="align-items-center card-bordered mt-3 p-3 d-md-none">
                <div className="row">
                  <div className="col-8">
                    <p className="mb-0 text-medium">
                      Save money in housing. Avoid no pet policies and pet deposits.
                    </p>
                  </div>
                  <div className="col-4 d-flex justify-content-around">
                    <span className="align-self-center text-primary fa fa-check" />
                    <span className="align-self-center text-danger fa fa-close" />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="container features-section bn-space-top">
          <h1 className="mb-3 mb-lg-4">Why AnimalAccess?</h1>

          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4 mt-lg-4">
              <div className="media mb-4">
                <span className="badge badge-round badge-primary mt-1 mr-4">1</span>
                <div className="media-body">
                  <h5>Most affordable service</h5>
                  <p className="text-muted text-small">100% money back guarantee</p>
                </div>
              </div>
              <div className="media mb-4">
                <span className="badge badge-round badge-primary mt-1 mr-4">2</span>
                <div className="media-body">
                  <h5>Hassle free process</h5>
                  <p className="text-muted text-small">99% approval rate, in just minutes</p>
                </div>
              </div>
              <div className="media mb-4">
                <span className="badge badge-round badge-primary mt-1 mr-4">3</span>
                <div className="media-body">
                  <h5>Without health records</h5>
                  <p className="text-muted text-small">Not reported on your health records</p>
                </div>
              </div>
              <div className="media mb-4">
                <span className="badge badge-round badge-primary mt-1 mr-4">4</span>
                  <div className="media-body">
                  <h5>Security</h5>
                <p className="text-muted text-small">Highest level of encrypted security</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 mt-lg-4">
              <div className="media mb-4">
                <span className="badge badge-round badge-primary mt-1 mr-4">5</span>
                <div className="media-body">
                  <h5>Your privacy is a priority</h5>
                  <p className="text-muted text-small">Only HIPAA compliant service</p>
                </div>
              </div>
              <div className="media mb-4">
                <span className="badge badge-round badge-primary mt-1 mr-4">6</span>
                <div className="media-body">
                  <h5>As required by law</h5>
                  <p className="text-muted text-small">Practitioners in your state as required by law</p>
                </div>
              </div>
              <div className="media mb-4">
                <span className="badge badge-round badge-primary mt-1 mr-4">7</span>
                <div className="media-body">
                  <h5>Fast service</h5>
                  <p className="text-muted text-small">Same day or next business day</p>
                </div>
              </div>
              <div className="media mb-4">
                <span className="badge badge-round badge-primary mt-1 mr-4">8</span>
                <div className="media-body">
                  <h5>Meets laws</h5>
                  <p className="text-muted text-small">Meets and exceeds all state and federal laws and regulations</p>
                </div>
              </div>
            </div>

            <div className="col-md-8 col-lg-4 mt-lg-4">
              <div className="mb-4 card">
                <div className="feature-card-body card-body d-flex justify-content-around align-items-center">
                  <img src="/images/payment_stripe.svg" width="60px"/>
                  <img src="/images/feature_moneyback.svg" />
                </div>
              </div>
              <div className="mb-4 card">
                <div className="feature-card-body card-body d-flex justify-content-around align-items-center">
                  <img src="/images/feature_hipaa.svg" />
                  <img src="/images/feature_ssl.svg" />
                </div>
              </div>
              <div className="mb-4 card">
                <div className="feature-card-body card-body d-flex justify-content-center align-items-center">
                  <span className="mr-3">
                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 10.5V15.5C0 15.7652 0.105357 16.0196 0.292893 16.2071C0.48043 16.3946 0.734784 16.5 1 16.5H2C2 17.2956 2.31607 18.0587 2.87868 18.6213C3.44129 19.1839 4.20435 19.5 5 19.5C5.79565 19.5 6.55871 19.1839 7.12132 18.6213C7.68393 18.0587 8 17.2956 8 16.5H14C14 17.2956 14.3161 18.0587 14.8787 18.6213C15.4413 19.1839 16.2044 19.5 17 19.5C17.7956 19.5 18.5587 19.1839 19.1213 18.6213C19.6839 18.0587 20 17.2956 20 16.5H21C21.2652 16.5 21.5196 16.3946 21.7071 16.2071C21.8946 16.0196 22 15.7652 22 15.5V3.5C22 2.70435 21.6839 1.94129 21.1213 1.37868C20.5587 0.816071 19.7956 0.5 19 0.5H10C9.20435 0.5 8.44129 0.816071 7.87868 1.37868C7.31607 1.94129 7 2.70435 7 3.5V5.5H5C4.53426 5.5 4.07493 5.60844 3.65836 5.81672C3.24179 6.025 2.87944 6.32741 2.6 6.7L0.2 9.9C0.170751 9.94347 0.147224 9.99052 0.13 10.04L0.0700001 10.15C0.0258661 10.2615 0.00215505 10.3801 0 10.5ZM16 16.5C16 16.3022 16.0586 16.1089 16.1685 15.9444C16.2784 15.78 16.4346 15.6518 16.6173 15.5761C16.8 15.5004 17.0011 15.4806 17.1951 15.5192C17.3891 15.5578 17.5673 15.653 17.7071 15.7929C17.847 15.9327 17.9422 16.1109 17.9808 16.3049C18.0194 16.4989 17.9996 16.7 17.9239 16.8827C17.8482 17.0654 17.72 17.2216 17.5556 17.3315C17.3911 17.4414 17.1978 17.5 17 17.5C16.7348 17.5 16.4804 17.3946 16.2929 17.2071C16.1054 17.0196 16 16.7652 16 16.5ZM9 3.5C9 3.23478 9.10536 2.98043 9.29289 2.79289C9.48043 2.60536 9.73478 2.5 10 2.5H19C19.2652 2.5 19.5196 2.60536 19.7071 2.79289C19.8946 2.98043 20 3.23478 20 3.5V14.5H19.22C18.9388 14.1906 18.5961 13.9435 18.2138 13.7743C17.8315 13.6052 17.418 13.5178 17 13.5178C16.582 13.5178 16.1685 13.6052 15.7862 13.7743C15.4039 13.9435 15.0612 14.1906 14.78 14.5H9V3.5ZM7 9.5H3L4.2 7.9C4.29315 7.7758 4.41393 7.675 4.55279 7.60557C4.69164 7.53615 4.84475 7.5 5 7.5H7V9.5ZM4 16.5C4 16.3022 4.05865 16.1089 4.16853 15.9444C4.27841 15.78 4.43459 15.6518 4.61732 15.5761C4.80004 15.5004 5.00111 15.4806 5.19509 15.5192C5.38907 15.5578 5.56725 15.653 5.70711 15.7929C5.84696 15.9327 5.9422 16.1109 5.98079 16.3049C6.01937 16.4989 5.99957 16.7 5.92388 16.8827C5.84819 17.0654 5.72002 17.2216 5.55557 17.3315C5.39112 17.4414 5.19778 17.5 5 17.5C4.73478 17.5 4.48043 17.3946 4.29289 17.2071C4.10536 17.0196 4 16.7652 4 16.5ZM2 11.5H7V14.28C6.40983 13.7526 5.63513 13.4797 4.84469 13.5209C4.05425 13.5621 3.31212 13.914 2.78 14.5H2V11.5Z" fill="#9AA4A9"/>
                    </svg>
                  </span>
                  <span className="text-large">Free shipping & no tax</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container experiences-section bn-space-top">
          <h1 className="mb-5 px-sm-5 text-center">Do you experience any of these conditions often?</h1>
          <img src="/images/mental_conditions.svg" width="100%" />
          <h4 className="mt-5 text-center">If you answered yes, you qualify.</h4>
          <h6 className="mb-3 text-center">99% approval rate. 100% money back guarantee.</h6>
        </div>

        <div className="container howto-section bn-space-top">
          <div className="container">
            <h1 className="mb-4 mb-lg-5">How does it work</h1>
            <p className="text-muted text-large">
              Gain full, legal, free access to "No Pet" housing, <br/>without extra fees and unfair deposits.
            </p>

            <div className="row no-gutters align-items-center mb-3">
              <div className="col-lg mb-7 mb-lg-0">
                <div className="howto-step-card p-3">
                  <p className="text-large">Step 1</p>
                  <h6>Answer fast & easy <br/>online questionnaire</h6>
                </div>
              </div>

              <div className="col-lg-1 text-center my-3 my-lg-0">
                <span className="badge badge-circle badge-primary">
                  <i className="fa fa-angle-right d-none d-lg-block big-icon"></i>
                  <i className="fa fa-angle-down d-lg-none big-icon"></i>
                </span>
              </div>

              <div className="col-lg mb-7 mb-lg-0">
                <div className="howto-step-card p-3">
                  <p className="text-large">Step 2</p>
                  <h6>Review and approval by <br/>licensed practitioner</h6>
                </div>
              </div>

              <div className="col-lg-1 text-center my-3 my-lg-0">
                <span className="badge badge-circle badge-primary">
                  <i className="fa fa-angle-right d-none d-lg-block big-icon"></i>
                  <i className="fa fa-angle-down d-lg-none big-icon"></i>
                </span>
              </div>

              <div className="col-lg mb-7 mb-lg-0">
                <div className="howto-step-card p-3">
                  <p className="text-large">Step 3</p>
                  <h6>Receive your ESA <br/>letters</h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container intro2-section bn-space-top bn-space-bottom">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <figure className="w-100">
                <img src="/images/housing.svg" className="img-fluid" />
              </figure>
            </div>

            <div className="col-lg-4 text-center text-lg-left">
              <h2 className="text-primary mb-3 mb-lg-4">ESA Housing Letter</h2>
              <div className="card price-card mb-3 mb-lg-4">
                <div className="card-body d-flex align-items-center">
                  <span className="mb-0">$99</span>
                </div>
              </div>
              <ul className="text-large text-left">
                <li>Exempt from “No Pet” housing</li>
                <li>Exempt from pet deposit and fee</li>
                <li>Valid in all housing</li>
                <li>State licensed professional signed letter within 1 business day</li>
                <li>All housing forms included</li>
                <li>100% money back guarantee</li>
              </ul>
              <Button size="lg" className="mt-md-4"
                      onClick={() => {this.props.history.push('/letters')}}>
                Get started
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
